var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("database-management-modal", {
    ref: "modal",
    attrs: { element: _vm.department },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass: "form-group",
                class: { "has-error": _vm.$v.selectedDepartment.$error },
              },
              [
                _c("p", [
                  _vm._v(
                    "Where would you like to move the users in this department?"
                  ),
                ]),
                _vm._v(" "),
                _c("label", { staticClass: "control-label" }, [
                  _vm._v("* Department"),
                ]),
                _vm._v(" "),
                _c("selectize", {
                  staticClass: "form-control selectize selectize-single",
                  attrs: {
                    name: "department",
                    options: _vm.handleDepartmentOptions(),
                  },
                  model: {
                    value: _vm.selectedDepartment,
                    callback: function ($$v) {
                      _vm.selectedDepartment = $$v
                    },
                    expression: "selectedDepartment",
                  },
                }),
                _vm._v(" "),
                _c("vuelidate-help", {
                  attrs: {
                    field: _vm.$v.selectedDepartment,
                    label: "Department",
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-lg btn-primary pull-right",
                attrs: {
                  click: _vm.saveDepartment,
                  type: "button",
                  "data-dismiss": "modal",
                },
              },
              [_c("i", { staticClass: "fa fa-check" }), _vm._v(" Save")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }